module.exports = __webpack_public_path__ + "media/images/pc/stores/karuizawa/karuizawa_concept_03-87f07ceed6af46cadddc780c8616b869.jpg";